import React from "react";

export default function Marketing() {
  return <div>Marketing</div>;
}
